import React from 'react';
import moment from 'moment';

const Subscription = ({ data = {} }) => {
    const { endAt, subscriptions = [] } = data;

    return (
        <div>
            <h4>SUBSCRIPTION</h4>
            <div className='m-t-1'>
                {`Subscription ends at ${moment(endAt).format('DD.MM.YYYY')}`}
            </div>
            <div className='m-t-1'>
                <div className='row'>
                    {
                        subscriptions.length ?
                            <div className='col-md-12 m-t-2'>
                                <div className='payment-history'>
                                    <div className='row'>
                                        <div className='col-md-12'>
                                            <div className='text-center bold'>Billing History</div>
                                        </div>
                                        <div className='col-md-12 m-t-1 payment-history_header'>
                                            <div className='row'>
                                                <div className='col-md-4'>Date</div>
                                                <div className='col-md-4'>Subscription is active</div>
                                                <div className='col-md-4'>Status</div>
                                            </div>
                                        </div>
                                        {
                                            [...subscriptions].reverse().map(sc => (
                                                <div
                                                    className='col-md-12 payment-history_entry'
                                                    key={sc.addedAt}
                                                >
                                                    <div className='row'>
                                                        <div className='col-md-4'>
                                                            {moment(sc.addedAt).format('DD.MM.YYYY HH:mm')}
                                                        </div>
                                                        <div className='col-md-4'>
                                                            {`${moment(sc.from).format('DD.MM.YYYY')} - ${moment(sc.to).format('DD.MM.YYYY')}`}
                                                        </div>
                                                        <div className='col-md-4'>
                                                            {sc.statusText}
                                                        </div>
                                                    </div>
                                                </div>
                                            ))
                                        }
                                    </div>
                                </div>
                            </div>
                            : null
                    }
                </div>
            </div>
        </div>
    );
};

export default Subscription;



// WEBPACK FOOTER //
// ./app/components/Users/Details/Subscription.jsx